export const BLACK_LIST_START_PATH = '/covenants/manager/email-blacklist';
export const DEFAULT_BLACK_LIST_ROWS_PER_PAGE = 10;

export const BLACK_LIST_PAGE_EYEBROW = 'Чорний список розсилки';
export const BLACK_LIST_CONTRAGENT_CODE_LABEL = 'ЄДРПОУ:';

export const BLACK_LIST_TABLE_TITLE = 'Заблоковані email';
export const BLACK_LIST_ADD_EMAIL_TITLE = 'Додати email до чорного списку';
export const BLACK_LIST_ADD_EMAIL_HINT =
  'Введіть email, який потрібно додати до чорного списку розсилки контрагента.';
export const BLACK_LIST_ADD_EMAIL_TOOLTIP = 'Додати email до чорного списку розсилки';
export const BLACK_LIST_ADD_EMAIL_LOADING_TOOLTIP = 'Триває обробка запиту';
export const BLACK_LIST_ADD_EMAIL_BUTTON_LABEL = 'Додати';
export const BLACK_LIST_ADD_EMAIL_LOADING_LABEL = 'Обробка...';

export const BLACK_LIST_EMAIL_COLUMN_LABEL = 'Email';
export const BLACK_LIST_BLOCKED_AT_COLUMN_LABEL = 'Дата блокування';
export const BLACK_LIST_ACTIONS_COLUMN_LABEL = 'Дії';
export const BLACK_LIST_EMPTY_STATE = 'Заблокованих email не знайдено';
export const BLACK_LIST_ROWS_PER_PAGE_LABEL = 'Рядків:';

export const BLACK_LIST_DELETE_TOOLTIP = 'Видалити email із чорного списку';
export const BLACK_LIST_DELETE_DISABLED_TOOLTIP =
  'Видалення буде доступно після підключення API';
